export default function() {
    var frontSlider = tns({
      container: '.whale-banner-front-slider',
      items: 1,
      speed: 1000,
      mouseDrag: true,
      nav: false,
      autoplay: false,
      autoplayButtonOutput: false,
      controlsText: ["<span></span>","<span></span>"],
      slideBy: 1,
      startIndex: 1
    });
  
    var frontIndex = frontSlider.getInfo().index;
  
    frontSlider.events.on('indexChanged', function(info){
      if (info.index > frontIndex) {
        backSlider.goTo('next');
      } else {
        backSlider.goTo('prev');
      }
      frontIndex = info.index;
    });
  
    var backSlider = tns({
      container: '.whale-banner-back-slider',
      items: 3,
      speed: 1000,
      mouseDrag: true,
      nav: false,
      autoplay: false,
      autoplayButtonOutput: false,
      controls: false,
      slideBy: 1,
      gutter: 189,
    });
}


// WEBPACK FOOTER //
// app/javascript/src/javascripts/page/whalegarden.js